import { j as jsxRuntimeExports } from "./doenetml-CDvV96YD.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
import { a as addCommasForCompositeRanges } from "./composites-CfLyaEMz.js";
const sq = React__default.memo(function Sq(props) {
  let { SVs, children } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  if (SVs._compositeReplacementActiveRange) {
    children = addCommasForCompositeRanges({
      children,
      compositeReplacementActiveRange: SVs._compositeReplacementActiveRange,
      startInd: 0,
      endInd: children.length - 1
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    "‘",
    children,
    "’"
  ] });
});
export {
  sq as default
};
